import client from './client'

const fetchLodir = () => {
  return client.get('/items/lodir', {
    fields: [
      'afangi.id',
      'afangi.title',
      'afangi.deiliskipulag.*',
      'afangi.hverfi.title',
      'slug',
      'gata.key',
      'gata.name',
      'title',
      'nr',
      'verd',
      'seld',
      'form_id',
      'i_auglysingu',
      'i_birtingu',
      'pdf_skra',
      'lodarstaerd',
      'nytingarhlutfall',
      'byggingarmagn_mest',
      'byggingarrettargjald',
      'byggingarrettargjald_utbod',
      'uppgroftur_fylling_vegna_gatnagerdar',
      'lagmarkstilbodsverd',
      'landnumer',
      'haedir',
      'lodargerd',
      'heildargjold',
      'fjoldi_ibuda',
      'byggingarmagn_ibudir_ofanjardar',
      'byggingarmagn_atvinnuhusnaedi',
      'byggingarmagn_kjallari',
      'byggingarmagn_bilgeymsla',
      'gatnagerdargjald_bilgeymsla',
      'hverfi',
      'hverfid.*',
      'upplysingar.*',
      'upplysingar.*.*',
    ],
    sort: 'i_birtingu',
  })
}

export default fetchLodir
